import createPerformanceEvent from './create-performance-event';
import {
  interactionToNextPaint,
  largestLayoutShiftNode,
  longtaskLongestFrame,
  longtasks,
  memory,
  removeLoadAbandonment,
} from './metrics';


/**
 * @callback sendClientEvent
 * @see
 * {@link https://github.com/buzzfeed/mono/tree/master/packages/frontend/client-event-tracking}
 */

/**
 * This function is provided as a convenience for tracking all custom metrics. This includes
 * removing loadAbandonment (if it is setup on the consuming app).
 * @param  {sendClientEvent}
 * @param  {Object} [options={}] - Configuration object
 * @param  {Array} [options.layers=[]] - An array containing an object or a function that returns an object representing fields to be sent to CET
 * @param  {Object} [options.profiling={}] - Options to pass to the longtask longest frame metric
 * including `ignore_pattern` and event `limit`.
 * @param  {Number} [options.sample_rate=0.1] - Rate at which to sample event requests (between 0 and 1)
 */
const trackCustom = (sendClientEvent, { layers = [], profiling = {}, sample_rate = 0.1 } = {}) => {
  const options = {
    layers,
    sample_rate,
    type: 'web_performance_metric',
  };

  const trackPerformanceMetricEventFlush = createPerformanceEvent(sendClientEvent, {
    ...options,
    flush: true,
  });

  const trackPerformanceMetricEvent = createPerformanceEvent(sendClientEvent, options);

  /**
   * To avoid running the profiler on pages that are not sampled, the sample_rate is configured by
   * the inline script that goes in the <head> of the document instead.
   */
  const trackPerformanceMetricEventProfiling = createPerformanceEvent(sendClientEvent, {
    ...options,
    sample_rate: 1,
  });

  removeLoadAbandonment();
  interactionToNextPaint(trackPerformanceMetricEvent);
  largestLayoutShiftNode(trackPerformanceMetricEventFlush);
  longtasks(trackPerformanceMetricEvent);
  longtaskLongestFrame(trackPerformanceMetricEventProfiling, profiling);
  memory(trackPerformanceMetricEventFlush);
};

export default trackCustom;
